import Storage from '@/common/storage';
import { StorageScopeKey } from '@/config/constant';

export default new Storage(StorageScopeKey.AUTH, process.env.VERSION);
